import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '@/components/login.vue'
import SsoMobilePage from '@/components/ssoMobile.vue'
import PincodePage from '@/components/pincode.vue'
import InsightsPage from '@/components/insights.vue'
import MembersPage from '@/components/members.vue'

import QuestionsPage from '@/components/questions.vue'
import Skills from '@/components/skills.vue'
import RewardsPage from '@/components/rewards.vue'
import BillingPage from '@/components/billing.vue'
import SettingsPage from '@/components/settings.vue'
import PowerupsPage from '@/components/power-ups.vue'
import HappilyVillage from '@/components/happily-village.vue'
import Integrations from '@/components/Integrations.vue'
import PageNotFound from '@/components/404.vue'
import register from '@/components/register.vue'
import setupWizard from '@/components/setup-wizard.vue'
import sparks from '@/components/sparks.vue'
import reports from '@/components/reports.vue'
import ssoLogin from '@/components/sso.vue'
import ssoLogout from '@/components/sso-logout.vue'
import rewardMessage from '@/components/wv-reward-message.vue'
import relationshipMapping from '@/components/wv-relationship-mapping.vue'
import documentDeveloper from '@/components/document-developer.vue'
import awards from '@/components/awards.vue'
import integrationsZapier from '@/components/integration-zapier.vue'
import firebase from 'firebase/app';
import 'firebase/auth';
import axios from 'axios'
Vue.use(Router)

let defaultPage = {}
const userData = localStorage.getItem('userData')
let user;
try {
  user = (userData)?decodeURIComponent(atob(userData)):null
  user = JSON.parse(user)
  if (user) {
    if (user.user_type == 'admin') {
      defaultPage = MembersPage
    } else {
      defaultPage = InsightsPage
    }
  } else {
    defaultPage = InsightsPage
  }
} catch (error) {
  
}


const routes = new Router({
  mode: 'history',
  routes: [
    // no authen
    {
      name: "login",
      path: '/login',
      component: LoginPage
    },
    {
      name: "sso-mobile",
      path: '/sso-mobile',
      component: SsoMobilePage
    },
    {
      name: "pincode",
      path: '/pincode',
      component: PincodePage
    },
    {
      path: '/sso-logout', component: ssoLogout
    },
    {
      name: "sso-login",
      path: '/sso-login/:id',
      component: ssoLogin
    },
    {
      name: "relationship-mapping",
      path: "/relationship-mapping",
      component: relationshipMapping
    },
    {
      name: "reward-message",
      path: "/reward-message",
      component: rewardMessage
    },
    {
      name: "user-registration",
      path: "/user-registration",
      component: register
    },
    // with tabs
    {
      name: "index",
      path: '/',
      component: defaultPage,
      meta: {
        auth: true
      }
    },
    {
      name: 'insightsWithTab',
      path: '/insights/:tab',
      component: InsightsPage,
      meta: {
        auth: true
      }
    },
    {
      name: 'insights',
      path: '/insights',
      component: InsightsPage,
      meta: {
        auth: true
      }
    },
    {
      name: "members",
      path: '/members/:tab',
      component: MembersPage,
      meta: {
        auth: true
      }
    },
    {
      path: '/members',
      component: MembersPage,
      meta: {
        auth: true
      }
    },
    {
      name: "power-ups",
      path: '/power-ups/:tab',
      component: PowerupsPage,
      meta: {
        auth: true
      }
    },
    {
      name: "power-ups",
      path: '/power-ups/:tab/:id',
      component: PowerupsPage,
      meta: {
        auth: true
      }
    },
    {
      path: '/power-ups',
      component: PowerupsPage,
      meta: {
        auth: true
      }
    },
    {
      name: "questions",
      path: '/questions/:tab',
      component: QuestionsPage,
      meta: {
        auth: true
      }
    },
    {
      path: '/questions',
      component: QuestionsPage,
      meta: {
        auth: true
      }
    },
    {
      name: "skills",
      path: '/skills/:tab',
      component: Skills,
      meta: {
        auth: true
      }
    },
    {
      path: '/skills',
      component: Skills,
      meta: {
        auth: true
      }
    },
    {
      name: "rewards",
      path: '/rewards/:tab',
      component: RewardsPage,
      meta: {
        auth: true
      }
    },
    {
      path: '/rewards',
      component: RewardsPage,
      meta: {
        auth: true
      }
    },
    
    {
      name: "happily-village",
      path: '/happily-village/:tab',
      component: HappilyVillage,
      meta: {
        auth: true
      }
    },
    {
      path: '/happily-village',
      component: HappilyVillage,
      meta: {
        auth: true
      }
    },
    {
      name: "integrations",
      path: '/integrations/:tab',
      component: Integrations,
      meta: {
        auth: true
      }
    },
    {
      path: '/integrations',
      component: Integrations,
      meta: {
        auth: true
      }
    },
    {
      name: "document-developer",
      path: '/document-developer/:tab',
      component: documentDeveloper,
      meta: {
        auth: true
      }
    },
    {
      path: '/document-developer',
      component: documentDeveloper,
      meta: {
        auth: true
      }
    },
    {
      name: "sparks",
      path: "/sparks/:tab",
      component: sparks,
      meta: {
        auth: true
      }
    },
    {
      path: "/sparks",
      component: sparks,
      meta: {
        auth: true
      }
    },
    {
      name: "reports",
      path: "/reports/:tab",
      component: reports,
      meta: {
        auth: true
      }
    },
    {
      path: "/reports",
      component: reports,
      meta: {
        auth: true
      }
    },
    {
      name: "awards",
      path: "/awards/:tab",
      component: awards,
      meta: {
        auth: true
      }
    },
    {
      path: "/awards",
      component: awards,
      meta: {
        auth: true
      }
    },
    // sigle tab
    {
      name: "billing",
      path: '/billing',
      component: BillingPage,
      meta: {
        auth: true
      }
    },
    {
      name: "settings",
      path: '/settings',
      component: SettingsPage,
      meta: {
        auth: true
      }
    },
    {
      name: "setup-wizard",
      path: "/setup-wizard",
      component: setupWizard,
      meta: {
        auth: true
      }
    },
    {
      name: "integration-zapier",
      path: "/integration-zapier",
      component: integrationsZapier,
      meta: {
        auth: true
      }
    },
    {
      name: "404",
      path: "*",
      component: PageNotFound,
      meta: {
        auth: true
      }
    }
  ]
})
routes.beforeEach(async (to, from, next) => {
  const path = {
    "login": "Login",
    "pincode": "Pincode",
    "sso-login": "Login",
    "insights": "Insights",
    "": false,
    "members": "Members",
    "newmembers": "Members",
    "power-ups": "Power Ups",
    "questions": "Questions",
    "skills": "Skills",
    "rewards": "Rewards",
    "billing": "Billing",
    "settings": "Settings",
    "happily-village": "Happily Village",
    "integrations": "Integrations",
    "relationship-mapping": "Relationship Mapping",
    "reward-message": "Reward Message",
    "user-registration": "User Registration",
    "setup-wizard": "Setup Wizard",
    "sparks": "Sparks",
    "document-developer": "Documentation",
  }
  const currentPate = to.path.split('/')[1]
  if (path[currentPate]) {
    document.title = `My Happily - ${path[currentPate]}`
  } else {
    document.title = "My Happily"
  }

  if (to.matched.some(record => record.meta.auth)) {
    if (!firebase.auth().currentUser) {
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      localStorage.pageBeforeLogin = to.path;
      next({
        path: '/login'
      })
    } else {
      if(user && user.company){
        const company = (await firebase.database().ref(`/company/${user.company}`).once('value')).val()
        if(company && company.ips){
          let ip = '';
          const url = 'https://api.ipify.org?format=json'
          await axios.get(url).then(response => {
            ip = response.data.ip
          })
          .catch(function (error) {
            console.log(error);
          });
          if(!company.ips.includes(ip)){
            firebase.auth().signOut();
            localStorage.removeItem("userData");
            localStorage.pageBeforeLogin = to.path;
            next({
              path: '/login'
            })
          }
        }
      }
      next()
    }
  } else {
    next()
  }
})
export default routes